import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import React, { PropsWithChildren } from "react"

type Props = PropsWithChildren<{
  title: string
  id: string
}>

const ArticleBodySection = ({ title, id, children, ...props }: Props) => (
  <div
    id={id}
    className="flex flex-col border-b-2 border-charcoal/10 py-32 last:border-b-0 [&_h2+*]:!pt-0"
    {...props}
  >
    <Typography
      className="mb-32"
      element="h2"
      size="h5"
      font="grotesk"
      weight="medium"
      color={Color.Charcoal}
      text={title}
    />
    {children}
  </div>
)

export default ArticleBodySection
